<template> </template>

<script>
import ConfigAPI from "@/api/config.js";
import BoastsAPI from "@/api/boasts.js";
import { setInterval } from "timers";

export default {
  name: "messageCentre",
  data() {
    return {
      followers: {
        displayRecentFollowers: true,
      },
    };
  },
  created() {
    this.setSettings();

    // pubsub
    this.eventBus.$on("new-follower", this.newFollower);
    this.eventBus.$on("goals-progress-update", this.goalProgress);
    this.eventBus.$on("new-donator-msg", this.bitsDonation);
    this.eventBus.$on("custom-notification", this.newNotification);
    this.eventBus.$on("stream-change", this.streamChange);
    this.eventBus.$on("bits-tx-cancelled", this.txCancelled);
    this.eventBus.$on("bits-tx-completed", this.txComplete);
    this.eventBus.$on("subscriber-boast", this.subBoast);
    this.eventBus.$on("new-subscriber", this.newSubscirber);
    this.eventBus.$on("hypetrain-event", this.hypetrainEvent);
    this.eventBus.$on(
      "channel-points-reward-redemption-add",
      this.channelPointsEvent
    );
    this.motd();
    this.getBoasts();
  },
  mounted() {},
  methods: {
    setSettings: function() {
      var config = ConfigAPI.getBroadcasterConfig();

      if (config.followers) {
        var followers = config.followers;
        if (followers.display_recent_followers) {
          this.followers.displayRecentFollowers =
            followers.display_recent_followers;
        }
      }

      return;
    },
    newFollower: function(username) {
      if (this.followers.displayRecentFollowers) {
        this.notification("New Follower!", username, 45000, true);
      }
    },
    goalProgress: function(progress) {
      if (progress.current_amount == progress.target_amount) {
        this.notification(
          "Twitch Goal Complete!",
          "We have achieved the Twitch Goal for " + progress.type + "!",
          45000,
          true
        );
        return;
      }
      this.notification(
        "Twitch Goal Progress Update",
        "We're getting closer to the target for " + progress.type ,
        45000,
        true
      );
    },
    bitsDonation: function(tx) {
      this.notification(
        "Bits Transaction!",
        tx.user_name +
          " - " +
          tx.product_data.cost.amount.toLocaleString() +
          " - BITS!",
        35000,
        true
      );
    },
    newNotification: function(notification) {
      notification.message += "\n - from " + notification.author;

      this.notification(
        notification.title,
        notification.message,
        notification.delay,
        true
      );
    },
    streamChange: function(change) {
      if (change.type == "live") {
        var message =
          change.user_name + " is now live, playing " + change.game_name;
        this.notification("Now Live!", message, 15000, true);
      }
    },
    subBoast: function(subscriber) {
      var message = subscriber.message;
      message += "\n - from " + subscriber.user_name;
      this.notification("Subscriber has Boasted!", message, 90000, true);
    },
    newSubscirber: function(subscriber) {
      this.notification("New Subscriber!", subscriber.user_name, 90000, true);
    },
    hypetrainEvent: function(event) {
      if (event.total == event.goal) {
        var message = "The hype train goal has been achieved!";
        this.notification("Twitch Hype Train Complete!", message, 90000, true);
      }
      var message =
        event.last_contribution.user +
        " contributed towards the hype train";
      this.notification("Hype Train contribution", message, 90000, true);
    },
    channelPointsEvent: function(event) {
      var message =
        event.user_name +
        " has redeemed " +
        event.reward.cost +
        " points for " +
        event.reward.title +
        "!";
      this.notification("Channel points redemption", message, 90000, true);
    },
    motd: function() {
      var globalConfig = ConfigAPI.getGlobalConfig();
      var broadcasterConfig = ConfigAPI.getBroadcasterConfig();

      if (globalConfig.message) {
        var motd = globalConfig.message;
        this.notification(motd.title, motd.msg, motd.ts, false);
      }
      if (broadcasterConfig.motd) {
        var motd = broadcasterConfig.motd;
        if (motd.msg == "") {
          return;
        }

        this.notification("Message Of The Day", motd.msg, motd.ts, true);
      }
    },
    displayBoasts: function(boasts) {
      for (var i = 0; i < boasts.length; i++) {
        this.notification(
          boasts[i].title + " - " + boasts[i].username,
          boasts[i].message,
          3000,
          true
        );
      }
    },
    getBoasts: function() {
      BoastsAPI.getBoasts()
        .then((resp) => {
          this.displayBoasts(resp.data);
        })
        .catch((error) => {
          this.sendEvent("api", "failure", "get-Boasts");
        });
    },
  },
};
</script>
